<div class="faq-component" (click)="onHide()">
  <div>
    <TitleAtom type="p" color="dark" size="nano" weight="medium-weight" text="{{title}}"></TitleAtom>
    <ButtonAtom [style]="'clear'" color="dark" icon="more"></ButtonAtom>
  </div>
  <div class="faq-answer {{ isHidden ? 'hide' : '' }}">
    <CmsHtmlRendererAtom [data]="text"></CmsHtmlRendererAtom>
  </div>
</div>
